<template>
	<type-wrapper class="type-E" padding>
		<type-grid row="1">
			<type-title large weight="normal" v-if="showData.title">{{ showData.title }}</type-title>
			<type-content large center v-if="showData.content">{{ showData.content }}</type-content>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 横幅文字说明
	import mixin from '../mixin.js'
	export default {
		name: 'type-E',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-E{
		color: #000000;
		background-color: #FAFAFA!important;
	}
</style>
